
const LandingFooter = () => {
  return (
    <footer className="bg-deep-blue text-white py-16">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                <img 
                  src="/lovable-uploads/3848e4a0-cee7-43d6-81a6-66811064660c.png" 
                  alt="Show Up! Logo"
                  className="w-6 h-6 object-contain"
                />
              </div>
              <span className="font-bold text-lg">Show Up!</span>
            </div>
            <p className="text-white/70 text-sm">
              The simplest way to start showing up for what matters.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <div className="space-y-2 text-sm">
              <div><span className="text-white/70">Coming Soon</span></div>
              <div><span className="text-white/70">Early Access</span></div>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <div className="space-y-2 text-sm">
              <div><span className="text-white/70">PACT Method</span></div>
              <div><span className="text-white/70">Blog</span></div>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-sm">
              <div><span className="text-white/70">Support</span></div>
              <div><span className="text-white/70">Feedback</span></div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-white/70 text-sm">
            © 2024 Show Up! All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
